// Import the functions you need from the SDKs you need
import {initializeApp} from "firebase/app";
import {getAnalytics} from "firebase/analytics";
import {getMessaging, getToken, onMessage} from "firebase/messaging";
import {useStorage} from "@vueuse/core";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries
export default async (token, callback) => {
    return new Promise(async (resolve, reject) => {
        try {
            const firebaseConfig = useStorage("firebaseConfig", {
                apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
                authDomain: `${import.meta.env.VITE_FIREBASE_PROJECT_ID}.firebaseapp.com`,
                projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
                storageBucket: `${import.meta.env.VITE_FIREBASE_PROJECT_ID}.firebasestorage.app`,
                messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
                appId: import.meta.env.VITE_FIREBASE_APP_ID,
                measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID,
            });

            const encodedFirebaseConfig = encodeURIComponent(JSON.stringify(firebaseConfig.value));

            const swRegistration = await navigator.serviceWorker.register(
                `/firebase-messaging-sw.js?firebaseConfig=${encodedFirebaseConfig}`,
            );
            // Initialize Firebase

            const app = initializeApp(firebaseConfig.value);
            const analytics = getAnalytics(app);
            const messaging = getMessaging(app);
            if (!token) {
                token = await getToken(messaging, {
                    serviceWorkerRegistration: swRegistration,
                    vapidKey: import.meta.env.VITE_WEB_PUSH_PUBLIC,
                });
            }
            onMessage(messaging, callback);
            resolve({token, messaging, onMessage});
        } catch (e) {
            console.log(e);
            reject(e);
        }
    });
};
